/* esm.sh - hast-util-is-element@3.0.0 */
export * from "/*hast-util-is-element@3.0.0/esnext/hast-util-is-element.mjs";
